// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setQuizForm, setState, setUpdateQuizForm } from "../redux/slice";

// export default function ThemeSelector({
//   themes = [],
//   themeData = [],
//   isView = false,
// }) {
//   const dispatch = useDispatch();
//   const { updateQuizForm, subThemes, selectedSubThemes } = useSelector(
//     (state) => state.quizManagement
//   );

//   console.log("selectedSubThemes", selectedSubThemes);
//   // 🔹 Initialize from backend data (themeData)
//   useEffect(() => {
//     if (!themeData || themeData.length === 0) return;

//     const data = themeData[0];
//     const theme = themes.find((t) => t.theme_id === data.theme_id);

//     if (theme) {
//       // Set selected theme in quizForm
//       dispatch(setUpdateQuizForm({ key: "themeId", value: theme.theme_id }));

//       // Set sub-themes
//       dispatch(setState({ key: "subThemes", value: theme.sub_theme || [] }));

//       // Set selected sub-themes
//       if (data.sub_themes && data.sub_themes.length > 0) {
//         const validSubs =
//           theme.sub_theme
//             ?.filter((st) => data.sub_themes.includes(st.theme_id))
//             .map((st) => st.theme_id) || [];
//         dispatch(setState({ key: "selectedSubThemes", value: validSubs }));
//       } else {
//         dispatch(setState({ key: "selectedSubThemes", value: [] }));
//       }
//     }
//   }, [themeData, themes, dispatch]);

//   // 🔹 On main theme change
//   const handleThemeChange = (e) => {
//     const themeId = Number(e.target.value);
//     const selectedTheme = themes.find((t) => t.theme_id === themeId);

//     dispatch(setQuizForm({ key: "themeId", value: themeId }));
//     dispatch(
//       setState({ key: "subThemes", value: selectedTheme?.sub_theme || [] })
//     );
//     dispatch(setState({ key: "selectedSubThemes", value: [] }));
//   };

//   // 🔹 On sub-theme checkbox toggle
//   const handleSubThemeToggle = (id, isChecked) => {
//     const updatedSubs = isChecked
//       ? [...selectedSubThemes, id]
//       : selectedSubThemes.filter((sid) => sid !== id);

//     dispatch(setState({ key: "selectedSubThemes", value: updatedSubs }));
//   };

//   return (
//     <div style={{ marginTop: "2%" }}>
//       {/* Theme Selector */}
//       <div className="row mb-3">
//         <div className="row">
//           <label className="col-sm-3 col-form-label font-medium text-gray-700">
//             Themes
//           </label>
//           <div className="col-sm-9">
//             <select
//               disabled={isView}
//               className="form-control"
//               value={updateQuizForm.themeId || ""}
//               onChange={handleThemeChange}
//             >
//               <option value="">-- Select Theme --</option>
//               {themes.map((t) => (
//                 <option key={t.theme_id} value={t.theme_id}>
//                   {t.name ?? `Theme ${t.theme_id}`}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Sub-Themes */}
//       {/* {updateQuizForm.themeId && subThemes?.length > 0 && (
//         <>
//           <label>
//             <strong>Sub Themes</strong>
//           </label>
//           <br />
//           {subThemes.map((sub) => (
//             <label
//               key={sub.theme_id}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginRight: "16px",
//                 marginBottom: "8px",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={selectedSubThemes.includes(sub.theme_id)}
//                 onChange={(e) =>
//                   handleSubThemeToggle(sub.theme_id, e.target.checked)
//                 }
//                 className="mr-2"
//               />
//               <span className="text-gray-700">{sub.name}</span>
//             </label>
//           ))}
//         </>
//       )} */}
//       {updateQuizForm.themeId && subThemes?.length > 0 && (
//         <>
//           <label>
//             <strong>Sub Themes</strong>
//           </label>
//           <br />
//           <div style={{ marginLeft: "2%" }}>
//             {subThemes.map((sub) => (
//               <label
//                 key={sub.theme_id}
//                 style={{
//                   display: "flex", // ensures label + checkbox on same line
//                   alignItems: "center",
//                   marginBottom: "8px",
//                   // marginRight: "10%",
//                 }}
//               >
//                 <input
//                   type="checkbox"
//                   disabled={isView}
//                   checked={selectedSubThemes.includes(sub.theme_id)}
//                   onChange={(e) =>
//                     handleSubThemeToggle(sub.theme_id, e.target.checked)
//                   }
//                   className="mr-2"
//                 />
//                 <span className="text-gray-700" style={{ marginLeft: "2%" }}>
//                   {sub.name}
//                 </span>
//               </label>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setQuizForm, setState, setUpdateQuizForm } from "../redux/slice";

export default function ThemeSelector({
  themes = [],
  themeData = [],
  isView = false,
}) {
  const dispatch = useDispatch();
  const { updateQuizForm, subThemes, selectedSubThemes } = useSelector(
    (state) => state.quizManagement
  );

  // 🔹 Initialize from backend data (themeData)
  useEffect(() => {
    if (!themeData) return;

    // ✅ Support both array or single object
    const data = Array.isArray(themeData) ? themeData[0] : themeData;
    if (!data?.theme_id) return;

    // Find the matching theme
    const theme = themes.find((t) => t.theme_id === data.theme_id);
    if (!theme) return;

    // ✅ Set main theme
    dispatch(setUpdateQuizForm({ key: "themeId", value: theme.theme_id }));

    // ✅ Set available sub-themes from that theme
    dispatch(setState({ key: "subThemes", value: theme.sub_theme || [] }));

    // ✅ Preselect given sub_theme IDs (backend sends them as array of IDs)
    if (data.sub_theme && data.sub_theme.length > 0) {
      dispatch(setState({ key: "selectedSubThemes", value: data.sub_theme }));
    } else {
      dispatch(setState({ key: "selectedSubThemes", value: [] }));
    }
  }, [themeData, themes, dispatch]);

  // 🔹 On main theme change
  const handleThemeChange = (e) => {
    const themeId = Number(e.target.value);
    const selectedTheme = themes.find((t) => t.theme_id === themeId);

    dispatch(setQuizForm({ key: "themeId", value: themeId }));
    dispatch(
      setState({ key: "subThemes", value: selectedTheme?.sub_theme || [] })
    );
    dispatch(setState({ key: "selectedSubThemes", value: [] }));
  };

  // 🔹 On sub-theme checkbox toggle
  const handleSubThemeToggle = (id, isChecked) => {
    const updatedSubs = isChecked
      ? [...selectedSubThemes, id]
      : selectedSubThemes.filter((sid) => sid !== id);

    dispatch(setState({ key: "selectedSubThemes", value: updatedSubs }));
  };

  return (
    <div style={{ marginTop: "2%" }}>
      {/* Theme Selector */}
      <div className="row mb-3">
        <div className="row">
          <label className="col-sm-3 col-form-label font-medium text-gray-700">
            Themes
          </label>
          <div className="col-sm-9">
            <select
              disabled={isView}
              className="form-control"
              value={updateQuizForm.themeId || ""}
              onChange={handleThemeChange}
            >
              <option value="">-- Select Theme --</option>
              {themes.map((t) => (
                <option key={t.theme_id} value={t.theme_id}>
                  {t.name ?? `Theme ${t.theme_id}`}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Sub-Themes */}
      {updateQuizForm.themeId && subThemes?.length > 0 && (
        <>
          <div className="row mb-3">
            <div className="row">
              <label className="col-sm-3 col-form-label font-medium text-gray-700">
                Sub Themes
              </label>

              <div className="col-sm-9">
                <select
                  disabled={isView}
                  className="form-control"
                  value={selectedSubThemes[0] || ""}
                  onChange={(e) =>
                    dispatch(
                      setState({
                        key: "selectedSubThemes",
                        value: e.target.value ? [Number(e.target.value)] : [],
                      })
                    )
                  }
                >
                  <option value="">-- Select Sub Theme --</option>

                  {subThemes.map((t) => (
                    <option key={t.theme_id} value={t.theme_id}>
                      {t.name ?? `Sub-theme ${t.theme_id}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* <label>
            <strong>Sub Themes</strong>
          </label>
          <div style={{ marginLeft: "2%" }}>
            {subThemes.map((sub) => (
              <label
                key={sub.theme_id || sub.id || sub}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <input
                  type="checkbox"
                  disabled={isView}
                  checked={selectedSubThemes.includes(
                    sub.theme_id || sub.id || sub
                  )}
                  onChange={(e) =>
                    handleSubThemeToggle(
                      sub.theme_id || sub.id || sub,
                      e.target.checked
                    )
                  }
                  className="mr-2"
                />
                <span className="text-gray-700" style={{ marginLeft: "2%" }}>
                  {sub.name || `Sub-theme ${sub.theme_id || sub}`}
                </span>
              </label>
            ))}
          </div> */}
        </>
      )}
    </div>
  );
}
